// extracted by mini-css-extract-plugin
export default {"slot":"PageArtistPill_slot__do4Fk"};